export const transformUppercase = (sourceString: string) => {
  if (sourceString) {
    const newString = sourceString.toLowerCase().replaceAll('_', ' ') || ''
    return newString.charAt(0).toUpperCase() + newString.slice(1)
  }
}
